export default __webpack_public_path__ + "static/media/gistswap-card05.612123d2.png";